"use strict";

// NodeList.forEach polyfill for IE
require('nodelist-foreach-polyfill');

var keyboardTrap = require('../../index.js');

var trap = document.getElementById('trap');
var btn = document.querySelector('button');
btn.addEventListener('click', function () {
  if (this.getAttribute('aria-pressed') === 'true') {
    keyboardTrap.untrap();
  } else {
    keyboardTrap.trap(this.parentNode);
  }
});
document.addEventListener('keyboardTrap', function (e) {
  console.log(this, e);
});
document.addEventListener('keyboardUntrap', function (e) {
  console.log(this, e);
});
trap.addEventListener('keyboardUntrap', function (e) {
  console.log(this, e);
  btn.innerText = 'Trap';
  btn.setAttribute('aria-pressed', 'false');
});
trap.addEventListener('keyboardTrap', function (e) {
  console.log(this, e);
  btn.innerText = 'Untrap';
  btn.setAttribute('aria-pressed', 'true');
});
